// extracted by mini-css-extract-plugin
export default {"P18-header":"P18Report_P18-header__xrhOw","divider":"P18Report_divider__vkcC+"};